<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/performanceUnitList' }">绩效单元</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="copy">复制</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'performance_unit' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['xxxxx'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                        <el-tooltip
                                            v-if="in_array(item.prop, ['quota_released'])"
                                            class="Tooltip4"
                                            effect="dark"
                                            :content="fieldTypeMap[item.prop]['tips']"
                                            placement="top-start"
                                        >
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="子级信息" name="2">
                    <vPerformanceUnitComponent v-if="flag" :postList="postList"></vPerformanceUnitComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vPerformanceUnitComponent from '../../listComponent/basicdata/performance/performanceUnitComponent.vue';
export default {
    inject: ['reload'],
    name: 'performanceUnitDetail',
    components: {
        draggableDetail,
        vPerformanceUnitComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '绩效单元详情',
            flag: false,
            postList: {
                parent_code: false,
                params: {
                    parent_code: ''
                }
            },
            fieldTypeMap: {
                quota_released: {
                    tips: '限额*释放率*年度释放系数'
                }
            }
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.id = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            return true;
        },
        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).performance_unit;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .performanceUnitDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.name;
                    this.postList.params.parent_code = this.data.code;
                    this.flag = true;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'copy',
                    id: this.data.id
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'update',
                    id: this.data.id
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'performanceUnitDelete', this.data.name, 'performanceUnitList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>